import { scheduleUpdateChecks } from '@sf/shared';

const SW_URL = '/service-worker.js';

let waitingWorker = null;
const listeners = new Set();

function setWaiting(worker) {
  waitingWorker = worker;
  listeners.forEach((listener) => listener(Boolean(worker)));
}

function watchRegistration(registration) {
  // O SW antigo (/sw.js) buscava tudo na rede: a página já está na versão nova, então
  // a troca para o SW do Workbox pode ser feita na hora, sem recarregar nem avisar.
  const legacyController = navigator.serviceWorker.controller?.scriptURL?.endsWith('/sw.js');

  const onInstalled = (worker) => {
    if (!navigator.serviceWorker.controller) return; // primeira instalação: nada a atualizar
    if (legacyController) {
      worker.postMessage({ type: 'SKIP_WAITING' });
      return;
    }
    setWaiting(worker);
  };

  if (registration.waiting) onInstalled(registration.waiting);

  registration.addEventListener('updatefound', () => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener('statechange', () => {
      if (worker.state === 'installed') onInstalled(worker);
    });
  });
}

/** Registra o Service Worker (apenas no build de produção — o CRA só o gera no build). */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => {
        watchRegistration(registration);
        scheduleUpdateChecks(registration);
      })
      .catch((err) => console.error('[SW] Falha ao registrar:', err));
  });
}

/** Avisa quando há versão nova aguardando ativação. */
export function onNeedRefresh(listener) {
  listeners.add(listener);
  listener(Boolean(waitingWorker));
  return () => listeners.delete(listener);
}
